export default "__VITE_ASSET__DoXjmbto__"